import React from "react";
import "./MofaBlore.css";
const MofaBlore = () => {
  return (
    <div class="mofaBloreContainer">
      <h1>
        MOFA <span>Attestation</span> in Bangalore
      </h1>
      <p>
        After HRD, MEA, & Embassy attestation, MOFA (Ministry of Foreign
        Affairs) attestation is the last procedure of certificate attestation.
        It is needed to prove the authenticity of the documents submitted by you
        to the officials.
      </p>
      <p>
        Goodwayattestation provides the genuine & affordable MOFA document
        attestation services including MOFA attestation in Bangalore for birth
        certificate for those who want to travel abroad for higher studies or
        employment opportunities. We provide MOFA attestation & verification
        services for all countries.
      </p>
    </div>
  );
};

export default MofaBlore;
